import React from "react";
import { Link, Route } from "react-router-dom";
import classnames from "classnames";
var clickHandler = function (to) {
    "#" + to === location.hash && location.reload();
};
var MenuLink = function (_a) {
    var _b = _a.id, id = _b === void 0 ? "menuLinkItem" : _b, label = _a.label, to = _a.to, iconClass = _a.iconClass, _c = _a.activeOnlyWhenExact, activeOnlyWhenExact = _c === void 0 ? true : _c, _d = _a.onClick, onClick = _d === void 0 ? function () { return clickHandler(to); } : _d;
    return (React.createElement(Route, { path: to, exact: activeOnlyWhenExact }, function (_a) {
        var match = _a.match;
        return (React.createElement("li", { id: id, className: classnames("nav-item") },
            React.createElement(Link, { to: to, onClick: onClick, className: "nav-link" },
                React.createElement("i", { className: classnames("iconfont", iconClass) }),
                label)));
    }));
};
export default MenuLink;
